// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const WarningGlyph: React.FC = () => {
    return <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="UI-Icon/Glyph/warning/$support-03" className="warning-glyph" fill="#FAAB19">
            <path d="M7.4002786,0.333299641 C7.6722746,-0.142693353 8.11504348,-0.143879174 8.38771708,0.333299641 L8.38771708,0.333299641 L15.6897467,13.1118514 C15.9617427,13.5878444 15.7358622,13.9758601 15.183715,13.9758601 L15.183715,13.9758601 L0.604280731,13.9758601 C0.0479762722,13.9758601 -0.174424586,13.5890302 0.0982490228,13.1118514 L0.0982490228,13.1118514 Z M7.88075598,10.8 C7.39430344,10.8 7,11.1943585 7,11.680756 C7,12.1673737 7.39430344,12.561512 7.88075598,12.561512 C8.36720852,12.561512 8.76151196,12.1673737 8.76151196,11.680756 C8.76151196,11.1943585 8.36720852,10.8 7.88075598,10.8 Z M8.75871564,3.8 L7.03174313,3.8 C6.79331299,3.8 6.6,4.10845 6.6,4.48888889 L6.6,4.48888889 L7.03174313,10 L8.75871564,10 L9.19045877,4.48888889 C9.19045877,4.10845 8.99714578,3.8 8.75871564,3.8 L8.75871564,3.8 Z"></path>
        </g>
    </g>
</svg>;
};

export default React.memo(WarningGlyph);
